import { ShieldCheck, Crosshair, Eye, RotateCcw } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const ROLES = [
  { icon: ShieldCheck, phase: "BEFORE THE TRADE", title: "RISK MANAGER", q: "Can I fully accept the predetermined risk?" },
  { icon: Crosshair, phase: "DURING THE TRADE", title: "EXECUTOR", q: "Has my process given me a reason to act?" },
  { icon: Eye, phase: "AFTER THE TRADE", title: "OBSERVER", q: "Did I follow my rules?" },
  { icon: RotateCcw, phase: "END OF TRADE", title: "RESET", q: "Outcome recorded. Next decision begins from zero." },
];

export default function Identity() {
  return (
    <section data-testid="identity-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="07 — Identity"
          testid="identity-heading"
          title={
            <>
              Strategy is only half the equation.
              <br />
              You still have to <span className="text-neon">execute.</span>
            </>
          }
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ROLES.map((r, i) => (
            <Reveal key={r.title} delay={0.08 * i} className="h-full">
              <div
                data-testid={`identity-card-${i}`}
                className="group flex h-full flex-col rounded-lg border border-line bg-charcoal p-7 transition-colors duration-500 hover:border-neon/50"
              >
                <div className="flex items-center justify-between">
                  <r.icon size={18} className="text-neon" />
                  <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-dim">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="mt-8 font-mono text-[9px] uppercase tracking-[0.25em] text-dim">
                  {r.phase}
                </div>
                <h3 className="mt-2 font-display text-xl font-extrabold uppercase tracking-tight text-white">
                  {r.title}
                </h3>
                <p className="mt-4 text-sm italic leading-relaxed text-mist">{r.q}</p>
                <div className="mt-auto pt-6">
                  <div className="h-px w-full bg-line transition-colors duration-500 group-hover:bg-neon/40" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-20 text-center">
            <span className="font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-6xl">
              Become the <span className="glow-text-neon text-neon">Executor.</span>
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
